import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/index.service';

@Component({
  selector: 'app-report-result',
  templateUrl: './report-result.component.html',
  styleUrls: ['./report-result.component.scss']
})
export class ReportResultComponent implements OnInit {
  @Output() eventEmitter = new EventEmitter()
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private globalService:GlobalService
  ) { }

  ngOnInit(): void {
  }
  btnClick(){
    if(this.data.buttonText) this.globalService.scrollTop()
  }
}
